<template>
  <TimeSegments
    v-bind="{
      autofocus,
      helpText,
      disabled,
      required,
      errorText,
      errorTextRequired,
      label
    }"
    v-model="time"
    @blur="$emit('blur')"
    @blurPart="$emit('blurPart', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
export default {
  name: 'TimeSegmented',
  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: ''
    },
    initialValue: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: null
    },
    errorText: {
      type: String,
      required: false
    },
    errorTextRequired: {
      type: String,
      required: false
    }
  },
  computed: {
    time: {
      get() {
        return this.$store.state.forms.time.time;
      },
      set(value) {
        this.$store.commit('forms/time/updateTime', value);
      }
    }
  },
  created() {
    if (this.initialValue) {
      const [initialHour, initialMinute] = this.initialValue?.split(':') || [];
      if (initialHour?.length && initialMinute?.length) {
        const hourToSet = this.padStartWithZeroes(initialHour, 2);
        const minuteToSet = this.padStartWithZeroes(initialMinute, 2);

        this.time =
          parseInt(hourToSet) >= 0 && parseInt(minuteToSet) >= 0
            ? `${hourToSet}:${minuteToSet}`
            : '00:00';
      }
    }

    this.$eventHub.$on('validateTimeSegmented', done => {
      this.$eventHub.$emit('validateTimeSegments', result => {
        this.$store.commit('forms/time/setIsValid', result);
        done();
      });
    });
  },
  destroyed() {
    this.$eventHub.$off('validateTimeSegmented');
  }
};
</script>
